import React, { useState } from 'react'
import { Sidebar } from './sidebar'
import { Content } from './content'
import { MembersDetail } from "../../shared/details/members"
import teamStore from '../../../stores/useTeam'
import clx from 'classnames'
import { useGeneral } from '../../../stores/useGeneral'

export const Team = () => {
    const {messages, detail} = teamStore(state=>state)
    const {darkmode} = useGeneral(state=>state)
   // Alternative way: const [messages, setMessages] = useState(teamMessages)

   const handle = () => {}
      
    return (
        <div id="chat" className={clx(darkmode, 'md:grid lg:grid-cols-11 scrollbar h-screen w-full overflow-hidden dark:text-white')}
      >
       <Sidebar />
       <Content 
              messages={messages}
              handle={handle}
              className={clx(!detail ? 'lg:col-span-8': 'lg:col-span-6')}

          />
       {detail && <MembersDetail /> }
      </div>
    )
}

